import { useHasActiveSystemManager } from '../hooks/use-has-active-system-manager'

import type { PropsWithChildren } from 'react'

type HasActiveSystemManagerProps = PropsWithChildren<{
	fallback?: React.ReactNode
}>

/**
 * Renders children only if user has System Manager role AND active SKU
 */
export const HasActiveSystemManager = ({
	children,
	fallback,
}: HasActiveSystemManagerProps) => {
	const isActive = useHasActiveSystemManager()

	if (isActive) {
		return <>{children}</>
	}

	return fallback ?? null
}
